import { render } from "./UserInfoDropdownMenu.vue?vue&type=template&id=437fbd70&scoped=true&ts=true"
import script from "./UserInfoDropdownMenu.vue?vue&type=script&lang=ts"
export * from "./UserInfoDropdownMenu.vue?vue&type=script&lang=ts"

import "./UserInfoDropdownMenu.vue?vue&type=style&index=0&id=437fbd70&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ms-frontend-vue_us_qa_v1.39.20_2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437fbd70"]])

export default __exports__